import React from 'react'
import styled from '@emotion/styled'

const enum LocalConstants {
  Radius = 40,
}

export const RatingTacho: React.FC<{ rating: number }> = ({ rating }) => (
  <div style={{ width: '4em', position: 'relative', margin: '0 auto', height: '0' }}>
    <svg viewBox='0,0,100,40' style={{ overflow: 'visible' }}>
      <g transform='translate(0, 0)'>
        <path d='M10,50A40,40 0 0 1 90,50' stroke='#e8e8e8' strokeWidth='10' fill='none' />
        <text x='49' y='48' textAnchor='middle' color='#111' fontSize='24' data-tid-rating>
          {' '}
          {rating}{' '}
        </text>

        <BlueArc rating={rating} />
        <OrangeArc rating={rating} />
      </g>
    </svg>
  </div>
)

// ================
// Local Components
// ================

const BlueArc: React.FC<{ rating: number }> = ({ rating }) => {
  const ratingCapped = rating <= 100 ? rating : 100

  return rating <= 150 ? (
    <Arc ratingCapped={ratingCapped} className='' testId='blue-arc' />
  ) : (
    <path />
  )
}

const OrangeArc: React.FC<{ rating: number }> = ({ rating }) => {
  let ratingCapped = 0
  if (rating > 100 && rating <= 150) {
    ratingCapped = 50
  }
  if (rating > 150) {
    ratingCapped = 100
  }

  return rating > 100 ? (
    <Arc ratingCapped={ratingCapped} className='orange' testId='orange-arc' />
  ) : (
    <path />
  )
}

const Arc: React.FC<{
  ratingCapped: number
  className: string
  testId: string
}> = ({ ratingCapped, testId, className }) => {
  const x = 50 + LocalConstants.Radius * Math.cos(Math.PI + Math.PI * (ratingCapped / 100))
  const y = 50 + LocalConstants.Radius * Math.sin(Math.PI + Math.PI * (ratingCapped / 100))
  const opts = { [`data-tid-${testId}`]: '' }

  return (
    <TachoPathStyled
      d={`M10,50A40,40 0 0 1 ${x},${y}`}
      strokeWidth='10'
      fill='none'
      className={className}
      {...opts}
    />
  )
}

// ======
// Styles
// ======

const TachoPathStyled = styled.path({
  '@keyframes tachomove': {
    '0%': { strokeDashoffset: 3.15 * 40 },
    '100%': { strokeDashoffset: 0 },
  },

  strokeDasharray: 3.15 * 40,
  strokeDashoffset: 3.15 * 40,
  animation: 'tachomove 0.5s ease-out forwards',
  stroke: '#004e9d',
  position: 'absolute',
  zIndex: 1,

  '&.orange': {
    stroke: '#ff9600',
    animation: 'tachomove 0.3s linear forwards',
    position: 'absolute',
    zIndex: 2,
  },
})
